import './Mailgun.scss';
import { ChannelBaseController } from '../ChannelBaseController';
import { ChannelsNames } from '../Channels';
export class MailgunController extends ChannelBaseController {
    static $inject = ['ApplicationService2', 'application', 'MAILGUNDOMAIN', 'ChannelsService'];
    constructor(ApplicationService2, application, MAILGUNDOMAIN, ChannelsService) {
        'ngInject';
        super(ChannelsNames.Mailgun, ChannelsService, ApplicationService2, application);
        this.ApplicationService2 = ApplicationService2;
        this.application = application;
        this.MAILGUNDOMAIN = MAILGUNDOMAIN;
        this.ChannelsService = ChannelsService;
    }
}
MailgunController.$inject = ['ApplicationService2', 'application', 'MAILGUNDOMAIN', 'ChannelsService'];
